import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
    { path: '/customer/apps/google-reviews', label: 'Google Reviews', icon: 'google-reviews.png' },
    { path: '/customer/apps/amazon-reviews', label: 'Amazon Reviews', icon: 'amazon-reviews.png' },
    { path: '/customer/apps/aliexpress-reviews', label: 'AliExpress Reviews', icon: 'aliexpress-reviews.png' },
    { path: '/customer/apps/yelp-reviews', label: 'Yelp Reviews', icon: 'yelp-reviews.png' },
    { path: '/customer/apps/g2-reviews', label: 'G2 Reviews', icon: 'g2-reviews.png' },
    { path: '/customer/apps/hotels-reviews', label: 'Hotels Reviews', icon: 'hotels-reviews.png' },
    { path: '/customer/apps/app-store-reviews', label: 'App Store Reviews', icon: 'app-store-reviews.png' },
    { path: '/customer/apps/capterra-reviews', label: 'Capterra Reviews', icon: 'capterra-reviews.png' },
    { path: '/customer/apps/booking-reviews', label: 'Booking Reviews', icon: 'booking-reviews.png' },
    { path: '/customer/apps/tripadvisor-reviews', label: 'Tripadvisor Reviews', icon: 'tripadvisor-reviews.png' },
    { path: '/customer/apps/airbnb-reviews', label: 'Airbnb Reviews', icon: 'airbnb-reviews.png' },
    { path: '/customer/apps/facebook-reviews', label: 'Facebook Reviews', icon: 'facebook-reviews.png' },
    { path: '/customer/apps/bbb-reviews', label: 'BBB Reviews', icon: 'bbb-reviews.png' },
    { path: '/customer/apps/etsy-reviews', label: 'Etsy Reviews', icon: 'etsy-reviews.png' },
    { path: '/customer/apps/opentable-reviews', label: 'OpenTable Reviews', icon: 'opentable-reviews.png' },
    { path: '/customer/apps/instagram-feed', label: 'Instagram Feed', icon: 'instagram-feed.png' },
    { path: '/customer/apps/whats-app-chat', label: 'WhatsApp Chat', icon: 'whatsApp-chat.png' },
    { path: '/customer/apps/instagram-chat', label: 'Instagram Chat', icon: 'instagram-chat.png' },
    { path: '/customer/apps/telegram-chat', label: 'Telegram Chat', icon: 'telegram-chat.png' },
    { path: '/customer/apps/line-chat', label: 'Line Chat', icon: 'line-chat.png' },
    { path: '/customer/apps/viber-chat', label: 'Viber Chat', icon: 'viber-chat.png' },
    { path: '/customer/apps/facebook-chat', label: 'Facebook Chat', icon: 'facebook-chat.png' },
    { path: '/customer/apps/ai-chatbot', label: 'AI Chatbot', icon: 'ai-chatbot.png' },
    { path: '/customer/apps/click-to-call', label: 'Click To Call', icon: 'click-to-call.png' },
    { path: '/customer/apps/countdown-timer', label: 'Countdown Timer', icon: 'countdown-timer.png' },
    { path: '/customer/apps/testimonials', label: 'Testimonials Slider', icon: 'testimonials-slider.png' },
    { path: '/customer/apps/cookie-consent', label: 'Cookie Consent', icon: 'cookie-consent-list-icon.png' },
    { path: '/customer/apps/age-verification', label: 'Age Verification', icon: 'age-verification-list-icon.png' },
    { path: '/customer/apps/business-hours', label: 'Business Hours', icon: 'business-hours-list-icon.png' },
    { path: '/customer/apps/announcement-bar', label: 'Announcement Bar', icon: 'announcement-bar-list-icon.png' },
    { path: '/customer/apps/number-counter', label: 'Number Counter', icon: 'number-counter.png' },
    { path: '/customer/apps/back-to-top', label: 'Back to Top', icon: 'back-to-top.png' },
    { path: '/customer/apps/facebook-like-button', label: 'Facebook Like Button', icon: 'facebook-like-button.png' },
    { path: '/customer/apps/facebook-share-button', label: 'Facebook Share Button', icon: 'facebook-share-button.png' },
    { path: '/customer/apps/qr-code', label: 'QR Code', icon: 'qr-code.png' },
    { path: '/customer/apps/logo-showcase', label: 'Logo Showcase', icon: 'logo-showcase.png' },
    { path: '/customer/apps/social-media-icons', label: 'Social Media Icons', icon: 'social-media-icons.png' },
    { path: '/customer/apps/team-showcase', label: 'Team Showcase', icon: 'team-showcase.png' },
    { path: '/customer/apps/faq', label: 'FAQ', icon: 'faq.png' },
    { path: '/customer/apps/spinning-wheel', label: 'Spinning Wheel', icon: 'spinning-wheel.png' },
    { path: '/customer/apps/pdf-embed', label: 'Pdf Embed', icon: 'pdf-embed.png' },
    { path: '/customer/apps/file-embed', label: 'File Embed', icon: 'file-embed.png' },
    { path: '/customer/apps/paypal-button', label: 'PayPal Button', icon: 'paypal-button.png' }, 
];

const SideBar = () => {
    const [search, setSearch] = useState('');
    const location = useLocation();

    const filteredMenu = menuItems.filter(item =>
        item.label.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="side-baar">
            <div className="logo-dashboard">
                <Link to="/customer/apps/google-reviews">
                    <img src={`${process.env.PUBLIC_URL}/images/logo-dashboard.svg`} alt="LOGO" />
                </Link>
            </div>

            {/* Search box */}
            <div className="serch-box">
                <button>
                    <i className="fa fa-search" aria-hidden="true"></i>
                </button>
                <input type="search" placeholder="Search here..." value={search} onChange={(e) => setSearch(e.target.value)}/>
            </div>

            {/* Menu List */}
            <div className="menu-list">
                <span>MAIN MENU</span>
                <div className="menu-inner">
                    <ul>
                        {filteredMenu.map((item, index) => (
                            <li key={index}>
                                <Link
                                    to={item.path}
                                    className={location.pathname === item.path ? 'active' : ''}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/app-icon/list-icons/${item.icon}`}
                                        alt={item.label}
                                        className='silver-icon'
                                    />
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                        {filteredMenu.length === 0 && (
                            <li style={{ padding: '10px', color: '#888' }}>No Menu Found.</li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default SideBar;
